import { useLingui } from "@lingui/react";
import { formatNumber } from "@mobility-item-page/utilities";
import { useAppConfig } from "../../../context/AppConfigProviderContext.tsx";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const Box = ({ box }: SpecProps<"box">) => {
  const { i18n } = useLingui();
  const { locale } = useAppConfig();

  if (!box) {
    return null;
  }

  const boxType = i18n.t({
    id: "itemPageLayout.keyInfo.boxType",
    message: "Box type",
    comment: "Field for 'Box type' for truck and bus in ad specification",
  });

  const boxLength = i18n.t({
    id: "itemPageLayout.keyInfo.boxLength",
    message: "Box length",
    comment: "Field for 'Box length' for truck and bus in ad specification",
  });

  const boxLengthValue = i18n.t({
    id: "itemPageLayout.common.meters.postfix",
    message: "{meters} m",
    comment: "Meters postfix in ad specification",
    values: {
      meters: formatNumber(box.length, locale),
    },
  });

  return (
    <>
      {box.box_type && <FieldValuePair field={boxType} value={box.box_type.value} />}
      {box.length && <FieldValuePair field={boxLength} value={boxLengthValue} />}
    </>
  );
};
